<template>
  <transition name="fade">
    <div class="global-loading">
      <div class="notif-wrapper">
        <div class="notif-text">
          <div class="modal-button-close" style="cursor: pointer">
            <i class="far fa-times-circle" @click="closeModal()"></i>
          </div>
          {{ $store.state.alertMsg }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  data() {
    return {
      password: '',
      confirmation: '',
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_NOTIF_CLOSE')
    },
    async reset() {
      const self = this
      const url = `${api}/api/v1/auth/reset`
      const authData = {
        confirmation: this.confirmation,
        password: this.password,
        token: this.$store.state.token,
      }
      try {
        const { data: auth } = await axios({
          method: 'POST',
          url,
          data: authData,
        })

        if (auth && auth.data) {
          this.$store.commit('SET_MODAL_RESET', false)
        }
      } catch (error) {}
    },
  },
}
</script>
